<template>
    <div>
        <div v-if="loadingNota" style="min-height: 350px; display: flex; justify-content: center; align-items: center;">
            <img src="/public/img/loading-bar.gif" />
        </div>
        <div v-else>

            <el-tabs type="border-card" v-model="tabAtivo" @tab-click="handleTabClick">

                <el-tab-pane name="notas" :label="nota.turma && nota.turma.metodo_avaliacao == 'quantitativo' ? 'NOTAS' : 'PARECER'">

                    <template v-if="nota.turma && nota.turma.metodo_avaliacao == 'quantitativo'">
                        <div class="u-text-right u-mb-5" style="margin-right: 6px;" v-if="$store.state.user.tipo == 6">
                            <el-button @click="openGerenciarCalcMedia()" type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                        </div>
                        <el-row :gutter="10" v-if="nota && nota.turma">
                            <el-col :xs="8" :sm="24" :md="24">
                                <div style="display: flex;">

                                    <div v-for="(periodo, i) in nota.turma.periodos_diario" :key="i" class="bloco-periodo" style="flex: 1; margin: 0 5px;">
                                        <table class="table table-striped table-nota">
                                            <thead>
                                                <tr class="linha-nota">
                                                    <th class="u-text-center" :colspan="defineQtdAtividades[i+1] + 2">{{ periodo }}</th>
                                                </tr>
                                                <tr>
                                                    <th class="u-text-left col-disciplina">Disciplinas</th>
                                                    <th v-for="k in defineQtdAtividades[i+1]" :key="`d${i}-${k}`" class="vertical-text">
                                                        Atividade {{ String(k).padStart(2, '0') }}
                                                    </th>
                                                    <th class="vertical-text">Média</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <!-- AS COLUNAS VÊM DA LISTA DE ATIVIDADES DA TURMA, NÃO DO JSON DO ALUNO:
                                                     SÓ ASSIM A COLUNA N É A MESMA AVALIAÇÃO PARA TODOS OS ALUNOS -->
                                                <tr v-for="(disc, j) in nota.atividades" :key="`n${i+j}`" class="linha-nota">

                                                    <td @dblclick="selecionaNota(j, i+1)" class="u-text-left u-pointer col-disciplina"><span class="u-pl-10">{{ nota['disciplinas'][j] }}</span></td>

                                                    <td v-for="k in defineQtdAtividades[i+1]" :key="`c${i}-${j}-${k}`" class="u-text-center celula-nota">

                                                        <nota-input v-if="podeEditarCelula()"
                                                                    v-model="valores[chaveCelula(j, i+1, k)]"
                                                                    :nota-maxima="maxPermitidoCelula(j, i+1, k)"
                                                                    :class="{ 'minha-nota': souAutorDaCelula(j, i+1, k) }"
                                                                    @alert-maximo="alertaMaximoCelula(j, i+1, $event)"
                                                                    @blur="salvarCelula(j, i+1, k)">
                                                        </nota-input>

                                                        <span v-else class="u-text-center">{{ valorDaPosicao(j, i+1, k) }}</span>

                                                    </td>

                                                    <td class="u-text-center">{{ nota.atividades[j][i+1]['m']['v'] }}</td>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </el-col>
                        </el-row>
                        
                        <el-row class="u-mt-20" :gutter="10">
                            <el-col :xs="8" :sm="24" :md="24">
                                <table class="table table-striped table-nota">
                                    <thead>
                                        <tr class="linha-nota">
                                            <th class="u-text-center" :colspan="colunasResumo">MÉDIA PARCIAL</th>
                                        </tr>
                                        <tr>
                                            <th class="u-text-center">Disciplina</th>
                                            <th v-for="(item, j) in nota.atividades" :key="j" class="u-text-center">{{ nota['disciplinas'][j] }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="linha-nota">
                                            <td class="u-text-center">NOTA</td>
                                            <td class="u-text-center" v-for="(item, j) in nota.atividades" :key="j">{{ item['m_parcial'] && (item['m_parcial']['v'] || item['m_parcial']['v'] === 0) ? item['m_parcial']['v'] : 'SN' }}</td>
                                        </tr>            
                                    </tbody>
                                </table>
                            </el-col>
                        </el-row>

                        <el-row class="u-mt-20" :gutter="10">
                            <el-col :xs="8" :sm="24" :md="24">
                                <table class="table table-striped table-nota">
                                    <thead>
                                        <tr class="linha-nota">
                                            <th class="u-text-center" :colspan="colunasResumo">RECUPERAÇÃO FINAL</th>
                                        </tr>
                                        <tr>
                                            <th class="u-text-center">Disciplina</th>
                                            <th @dblclick="selecionaNota(j, 'r')" v-for="(item, j) in nota.atividades" :key="j" class="u-text-center u-pointer">{{ nota['disciplinas'][j] }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="linha-nota">
                                            <td class="u-text-center">NOTA</td>
                                            <td @dblclick="removerNota(j, 'r', null)" v-for="(item, j) in nota.atividades" :key="j" class="u-text-center u-pointer">

                                                <span v-if="$store.state.user.id == item['r']['u']" style="font-weight: bold; color: #00aaff;">
                                                    {{ (item['r'] && item['r']['v'] ? item['r']['v'] : '') }}
                                                </span>
                                                <span v-else>
                                                    {{ (item['r'] && item['r']['v'] ? item['r']['v'] : '') }}
                                                </span>
                                                
                                                
                                            </td>
                                        </tr>            
                                    </tbody>
                                </table>                            
                            </el-col>
                        </el-row>

                        <el-row class="u-mt-20" :gutter="10">
                            <el-col :xs="8" :sm="24" :md="24">
                                <table class="table table-striped table-nota">
                                    <thead>
                                        <tr class="linha-nota">
                                            <th class="u-text-center" :colspan="colunasResumo">MÉDIA FINAL</th>
                                        </tr>
                                        <tr>
                                            <th class="u-text-center">Disciplina</th>
                                            <th v-for="(item, j) in nota.atividades" :key="j" class="u-text-center">{{ nota['disciplinas'][j] }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="linha-nota">
                                            <td class="u-text-center">NOTA</td>
                                            <td class="u-text-center" v-for="(item, j) in nota.atividades" :key="j">{{ item['m_final'] && item['m_final']['v'] ? item['m_final']['v'] : '' }}</td>
                                        </tr>            
                                    </tbody>
                                </table>
                            </el-col>
                        </el-row>

                    </template>

                    <template v-else-if="nota.turma">

                        <fieldset v-for="(periodo, i) in nota.turma.periodos_diario" :key="i" class="fieldset-nota">
                            <legend>PARECER {{ periodo }}</legend>

                            <el-button v-if="podeEditarParecer" @click="abrirParecer(i + 1, periodo, nota.parecer[i + 1])"
                                class="btn-editar-parecer" type="info" title="Editar parecer"
                                icon="el-icon-edit" size="mini" plain></el-button>

                            {{ nota.parecer[i + 1] }}
                        </fieldset>

                    </template>

                </el-tab-pane>

                <el-tab-pane name="parecer" :label="nota.turma && nota.turma.metodo_avaliacao == 'quantitativo' ? 'PARECER' : 'PARECER FINAL'">

                    <template v-if="nota && nota.notas_parecer && nota.notas_parecer.parecer">
                        <el-row :gutter="10" v-for="(item, i) in nota.notas_parecer.parecer" :key="i">
                            <el-col :xs="24" :sm="24" :md="24">

                                <div style="border: 1px solid #a9a9a9; border-radius: 12px; padding: 30px; position: relative;">
                                    <el-button v-if="podeEditarParecer" @click="abrirParecer(i, i + 'º Trimestre', item)"
                                        class="btn-editar-parecer" type="info" title="Editar parecer"
                                        icon="el-icon-edit" size="mini" plain></el-button>

                                    <div style="font-size: 17px;">Parecer / Observação - {{ i }}º Trimestre</div>
                                    <div v-if="item">                                    
                                        <hr class="u-mt-30">{{ item }}</hr>
                                    </div>
                                    <div v-else>
                                        <hr class="u-mt-30" />
                                        <hr class="u-mt-30" />
                                        <hr class="u-mt-30" />
                                        <hr class="u-mt-30" />
                                    </div>
                                </div>

                            </el-col>
                        </el-row>
                    </template>

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">

                            <div style="border: 1px solid #a9a9a9; border-radius: 12px; padding: 30px;">
                                <span style="font-size: 17px;">Resultados finais</span>
                                <i>
                                    Conselho de classe - O parecer conclusivo é de caráter coletivo e deverá ser elaborado pelo conselho de classe com a
                                    presença de todos os professores, conforme estabelecido no regimento escolar.

                                </i>
                                <div v-if="nota.conselho_parcial">                                    
                                    <hr class="u-mt-30"><span v-if="nota.parecer_final">{{ nota.parecer_final }}<br/></br></span>{{ nota.conselho_parcial['observacao'] }}</hr>
                                </div>
                                <div v-else-if="nota.conselho_final">                                    
                                    <hr class="u-mt-30"><span v-if="nota.parecer_final">{{ nota.parecer_final }}<br/></br></span>{{ nota.parecer_final }} {{ nota.conselho_final['observacao'] }}</hr>
                                </div>
                                <div v-else>
                                    <hr class="u-mt-30" />
                                    <hr class="u-mt-30" />
                                    <hr class="u-mt-30" />
                                    <hr class="u-mt-30" />
                                </div>
                            </div>

                        </el-col>
                    </el-row>

                </el-tab-pane>

                <el-tab-pane name="observacoes" label="OBSERVAÇÕES">
                    <div class="container-table">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>Data</th>
                                    <th>Observação</th>
                                    <th>Usuário</th>
                                </tr>
                            </thead>
                            <tbody v-if="!loadingObservacoes">
                                <tr v-for="item in observacoes" :key="item.id">
                                    <td>{{ $moment(item.created_at).format('DD/MM/YYYY HH:mm') }}</td>
                                    <td>{{ formatarTexto(item.observacao) }}</td>
                                    <td>{{ item.user ? item.user.name : '-' }}</td>
                                    
                                </tr>
                            </tbody>
                        </table>
                        <div v-if="loadingObservacoes" class="u-text-center u-mt-25">
                            <img src="/public/img/loading-bar.gif" />
                        </div>
                        <el-row :gutter="10" v-if="!loadingObservacoes">
                            <el-col :xs="24" :sm="12" :md="12">
                                <div class="u-text-left u-mt-10">
                                    Mostrando {{ paginateObservacoes.from }} até {{ paginateObservacoes.to }} de {{ paginateObservacoes.qtdItens }} registros encontrados.
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="12" v-if="paginateObservacoes.qtdItens > 30">
                                <div class="u-text-right">
                                        <el-pagination :current-page='paginateObservacoes.page' class="u-mt-10" :total="paginateObservacoes.qtdItens" @current-change="getPagePagination" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                                    </div>
                            </el-col>
                        </el-row>
                    </div>
                </el-tab-pane>

            </el-tabs>
            <div class="u-text-right u-mt-10">
                <el-button type="primary" @click="close">FECHAR</el-button>
            </div>

        </div>        

        <el-dialog :close-on-click-modal="false" :title="`GERENCIAR PARECER - ${changeParecer.periodo_nome}`" width="50%" top="40px" :visible.sync="dialogChangeParecer" v-on:close="closeDialogChangeParecer" append-to-body>
            <div v-if="dialogChangeParecer" style="margin-top: 20px;">
                <el-form @submit.native.prevent="onSubmitChangeParecer" :model="changeParecer" ref="changeParecer" label-position="top">

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Parecer" prop="parecer" key="parecer">
                                <el-input type="textarea" :rows="10" v-model="changeParecer.parecer"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <i>Atenção: Para fins de rastreabilidade, será criado um log associando o seu usuário ao cadastro deste parecer.</i>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item class="u-text-right u-mt-15">
                                <el-button type="primary" native-type="submit">SALVAR</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </el-form>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="GERENCIAR NOTA" width="20%" top="40px" :visible.sync="dialogChangeNota" v-on:close="closeDialogChangeNota" append-to-body>
            <div v-if="dialogChangeNota" style="margin-top: 20px;">
                <el-form @submit.native.prevent="onSubmitChangeNota" :model="changeNota" ref="changeNota" label-position="top">
                    
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="nota" prop="nota" :rules="[$requiredBlur]" key="nota">
                                <el-input v-model="changeNota.nota" maxlength="191"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <i>Atenção: Para fins de rastreabilidade, será criado um log associando o seu usuário ao cadastro desta nota.</i>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item class="u-text-right u-mt-15">
                                <el-button type="primary" id="btn-modelo" native-type="submit">SALVAR</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>                        
                    
                </el-form>
            </div>
        </el-dialog>

        <el-dialog append-to-body :close-on-click-modal="false" title="GERENCIAR CÁLCULO DE MÉDIA" top="40px" width="30%" :visible.sync="dialogGerenciarCalcMedia">
            <div v-if="dialogGerenciarCalcMedia" style="margin-top: 20px;">
                
                <el-form @submit.native.prevent="onSubmitGerenciarCalcMedia()" :model="calcNota" ref="calcNota" label-position="top">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Situação" prop="qtd_dvisao" key="qtd_dvisao">
                            <el-select style="z-index: 1000;" v-model="calcNota.qtd_dvisao">
                                <el-option key="" label="Padrão do sistema" value=""></el-option>
                                <el-option :key="1" label="÷ 1" :value="1"></el-option>
                                <el-option :key="2" label="÷ 2" :value="2"></el-option>                                
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-row :gutter="10"> 
                        <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                            <el-button type="primary" native-type="submit" class="u-mt-5">SALVAR</el-button>
                        </el-col>
                    </el-row>
                </el-form>
                
            </div>
        </el-dialog>
    </div>
</template>
<script>

import Decimal from "../../../../shared/moneys/component.vue"
import NotaInput from '@/shared/nota-input/nota-input.vue'

export default {
    props: ['id', 'turma_id', 'aluno_id', 'mostra_gerenciar_nota'],
    data: () => ({
        //TETO DA SOMA DAS ATIVIDADES DE UM PERÍODO, IGUAL AO DO BACKEND
        NOTA_MAXIMA_PERIODO: 10,
        //MÍNIMO DE COLUNAS DA GRADE; CRESCE SE ALGUMA DISCIPLINA TIVER MAIS ATIVIDADES
        COLUNAS_MINIMAS: 4,
        //VALOR EM EDIÇÃO POR CÉLULA, INDEXADO POR "disciplina|periodo|posicao"
        valores: {},
        //FILA QUE SERIALIZA AS GRAVAÇÕES DE CÉLULA
        fila: Promise.resolve(),
        dialogGerenciarCalcMedia: false,
        alunoSelected: {},
        defineQtdAtividades: {},
        loadingObservacoes: false,
        tabAtivo: 'notas',
        nota: {},
        loadingNota: true,
        dialogChangeNota: false,
        observacoes: [],
        paginateObservacoes: {
            page: 1,
            qtdItens: null,
            from: '',
            to: ''
        },
        changeNota: {
            aluno_id: '',
            turma_id: '',
            disciplina: '',
            periodo: '',
            nota: ''
        },
        dialogChangeParecer: false,
        changeParecer: {
            aluno_id: '',
            turma_id: '',
            periodo: '',
            periodo_nome: '',
            parecer: ''
        },
        calcNota: {
            qtd_dvisao: ''
        }
    }),
    computed: {
        //mesma porta do lançamento de nota pelo painel: só onde o gerenciamento está
        //habilitado e para quem pode alterar (SMED-Pedagógico é somente leitura)
        podeEditarParecer() {

            return !!this.mostra_gerenciar_nota && Number(this.$store.state.user.tipo) !== 7;
        },

        //LARGURA DAS TABELAS DE RESUMO: "Disciplina" MAIS UMA COLUNA POR DISCIPLINA.
        //ERA FIXO EM 11 E DESALINHAVA A FAIXA DO TÍTULO QUANDO A TURMA TINHA OUTRA
        //QUANTIDADE DE DISCIPLINAS.
        colunasResumo() {

            let qtd = this.nota && this.nota.atividades ? Object.keys(this.nota.atividades).length : 0;

            return qtd + 1;
        },

        //A GRADE DE NOTAS SEGUE A MESMA PORTA, MAIS O ENCERRAMENTO DO CONSELHO PARCIAL
        diarioBloqueado() {

            if(!this.podeEditarParecer)
                return true;

            let fase = this.nota && this.nota.turma ? Number(this.nota.turma.fase_diario) : 0;

            return fase >= 3;
        }
    },
    mounted () {
        
        this.getNota();        
    },
    methods: {

        // ------------------------------------------------------------------
        // GRADE DE NOTAS EDITÁVEL
        // A coluna N de um período é a N-ésima atividade daquela disciplina,
        // conforme a lista que o backend devolve em nota.avaliacoes. Montar a
        // grade pelo JSON do aluno não serve: ele pode não ter todas as chaves,
        // e a mesma coluna apontaria para atividades diferentes por aluno.
        // ------------------------------------------------------------------

        montaGrade(){

            let colunas = {};
            let valores = {};

            for(let periodoIndex in this.nota.turma.periodos_diario){

                let periodo = Number(periodoIndex) + 1;
                let maior = 0;

                for(let disciplina in this.nota.atividades){

                    let lista = this.avaliacoesDe(disciplina, periodo);

                    if(lista.length > maior)
                        maior = lista.length;
                }

                colunas[periodo] = Math.max(this.COLUNAS_MINIMAS, maior);
            }

            //ESTADO DE EDIÇÃO DE CADA CÉLULA, A PARTIR DO QUE ESTÁ GRAVADO
            for(let disciplina in this.nota.atividades){

                for(let periodo in colunas){

                    for(let k = 1; k <= colunas[periodo]; k++)
                        valores[this.chaveCelula(disciplina, periodo, k)] = this.valorDaPosicao(disciplina, periodo, k);
                }
            }

            this.defineQtdAtividades = colunas;
            this.valores = valores;
        },

        chaveCelula(disciplina, periodo, k){

            return `${disciplina}|${periodo}|${k}`;
        },

        avaliacoesDe(disciplina, periodo){

            if(!this.nota.avaliacoes || !this.nota.avaliacoes[disciplina] || !this.nota.avaliacoes[disciplina][periodo])
                return [];

            return this.nota.avaliacoes[disciplina][periodo];
        },

        avaliacaoDaPosicao(disciplina, periodo, k){

            let lista = this.avaliacoesDe(disciplina, periodo);

            return lista[k - 1] ? lista[k - 1].id : null;
        },

        celulaGravada(disciplina, periodo, k){

            let id = this.avaliacaoDaPosicao(disciplina, periodo, k);

            if(!id)
                return null;

            let bloco = this.nota.atividades[disciplina] ? this.nota.atividades[disciplina][periodo] : null;

            return bloco && bloco[id] ? bloco[id] : null;
        },

        valorDaPosicao(disciplina, periodo, k){

            let celula = this.celulaGravada(disciplina, periodo, k);

            return celula && celula.v !== null && celula.v !== undefined ? celula.v : '';
        },

        souAutorDaCelula(disciplina, periodo, k){

            let celula = this.celulaGravada(disciplina, periodo, k);

            return !!celula && celula.u == this.$store.state.user.id;
        },

        //TODA INTERSEÇÃO É EDITÁVEL. O DESCONTROLE DE ATIVIDADES ANTIGO VINHA DE A
        //CRIAÇÃO DEPENDER DO ALUNO; AQUI ELA DEPENDE DA POSIÇÃO DA COLUNA, QUE É A
        //MESMA PARA A TURMA TODA — E O TETO É A LARGURA DA GRADE.
        podeEditarCelula(){

            return !this.diarioBloqueado;
        },

        maxPermitidoCelula(disciplina, periodo, k){

            let soma = 0;
            let total = this.defineQtdAtividades[periodo] || 0;

            for(let outra = 1; outra <= total; outra++){

                if(outra === k)
                    continue;

                let v = this.valores[this.chaveCelula(disciplina, periodo, outra)];
                let n = this.converteNota(v);

                if(n !== null)
                    soma += n;
            }

            let restante = Math.round((this.NOTA_MAXIMA_PERIODO - soma) * 100) / 100;

            return restante < 0 ? 0 : restante;
        },

        converteNota(valor){

            if(valor === '' || valor === null || valor === undefined)
                return null;

            let n = parseFloat(String(valor).replace(',', '.'));

            return isNaN(n) ? null : n;
        },

        salvarCelula(disciplina, periodo, k){

            if(this.diarioBloqueado)
                return;

            let chave = this.chaveCelula(disciplina, periodo, k);
            let novo = this.valores[chave];
            let gravado = this.valorDaPosicao(disciplina, periodo, k);

            let novoNum = this.converteNota(novo);
            let gravadoNum = this.converteNota(gravado);

            if(novoNum === gravadoNum)
                return;

            //LIMPAR PASSA PELO removerNota, QUE SÓ DEIXA O AUTOR DA NOTA EXCLUIR
            if(novoNum === null){

                this.excluirCelula(disciplina, periodo, k);
                return;
            }

            //UMA GRAVAÇÃO POR VEZ. SEM A FILA, DUAS CÉLULAS SALVAS EM SEGUIDA PODEM
            //LER O MESMO ESTADO DO BANCO E UMA SOBRESCREVER A OUTRA.
            this.enfileira(() => {

                let avaliacaoId = this.avaliacaoDaPosicao(disciplina, periodo, k);

                if(avaliacaoId)
                    return this.gravarCelula(disciplina, periodo, k, avaliacaoId);

                //A ATIVIDADE QUE FALTA É CRIADA SEM PERGUNTAR: ELA NASCE SÓ PARA ESTA
                //DISCIPLINA E PERÍODO, E A QUANTIDADE É LIMITADA PELA LARGURA DA GRADE.
                return this.criarAtividadesAte(disciplina, periodo, k).then((ultimoId) => {

                    if(!ultimoId){

                        this.$set(this.valores, chave, gravado);
                        return;
                    }

                    return this.gravarCelula(disciplina, periodo, k, ultimoId);
                });
            });
        },

        enfileira(tarefa){

            this.fila = this.fila.then(tarefa).catch(() => {});

            return this.fila;
        },

        /**
         * Cria, uma a uma, as atividades que faltam até a posição k. Em sequência de
         * propósito: cada chamada precisa enxergar a anterior para a numeração sair
         * certa. O id devolvido é o da última, que é a que ocupa a posição k.
         */
        criarAtividadesAte(disciplina, periodo, k){

            let faltam = k - this.avaliacoesDe(disciplina, periodo).length;
            let ultimoId = null;

            //EM SEQUÊNCIA DE PROPÓSITO: CADA CHAMADA PRECISA ENXERGAR A ANTERIOR PARA
            //A NUMERAÇÃO SAIR CERTA. O ÚLTIMO ID É O QUE OCUPA A POSIÇÃO k.
            let corrente = Promise.resolve();

            for(let i = 0; i < faltam; i++){

                corrente = corrente.then(() => {

                    if(i > 0 && !ultimoId)
                        return;

                    return this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/avaliacao/store`, {
                        turma_id: this.nota.turma_id,
                        area_conhecimento_id: disciplina,
                        periodo_diario: periodo
                    }, this.$store.getters.getHeaderAuth).then(response => {

                        if(response.data && response.data.erro){

                            ultimoId = null;
                            window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});
                            return;
                        }

                        ultimoId = response.data.id;
                    });
                });
            }

            return corrente
                    .then(() => ultimoId)
                    .catch((error) => { this.$store.commit('throwException', error); return null; });
        },

        gravarCelula(disciplina, periodo, k, avaliacaoId){

            let chave = this.chaveCelula(disciplina, periodo, k);
            let gravado = this.valorDaPosicao(disciplina, periodo, k);

            let atividades = {};
            atividades[avaliacaoId] = { u: '', v: this.valores[chave] };

            let payload = {
                turma: this.nota.turma_id,
                disciplina: Number(disciplina),
                periodo_diario: Number(periodo),
                avaliacao: '',
                alunos: [{ id: this.nota.aluno_id, nota_id: this.nota.id, nome: '', atividades: atividades }]
            };

            return this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/nota/storeNota`, payload, this.$store.getters.getHeaderAuth).then(response => {

                let msg = response.data ? (response.data.erro || response.data.error) : null;

                if(msg){

                    window.eventBus.$emit('alert', {msg: msg, type: 'warning'});
                    this.$set(this.valores, chave, gravado);
                    return;
                }

                //RECARREGA PARA TRAZER A MÉDIA RECALCULADA E A ATIVIDADE NOVA, SE HOUVE
                return this.recarregaNota();

            }).catch((error) => { this.$store.commit('throwException', error); });
        },

        excluirCelula(disciplina, periodo, k){

            let chave = this.chaveCelula(disciplina, periodo, k);
            let gravado = this.valorDaPosicao(disciplina, periodo, k);

            return this.enfileira(() =>

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/nota/removerNota`, {
                    aluno_id: this.nota.aluno_id,
                    turma_id: this.nota.turma_id,
                    disciplina: Number(disciplina),
                    periodo: Number(periodo),
                    atividade: this.avaliacaoDaPosicao(disciplina, periodo, k)
                }, this.$store.getters.getHeaderAuth).then(response => {

                    let msg = response.data ? (response.data.erro || response.data.error) : null;

                    if(msg){

                        window.eventBus.$emit('alert', {msg: msg, type: 'warning'});
                        //DESFAZ NA TELA: A NOTA CONTINUA GRAVADA
                        this.$set(this.valores, chave, gravado);
                        return;
                    }

                    return this.recarregaNota();

                }).catch((error) => { this.$store.commit('throwException', error); })
            );
        },

        recarregaNota(){

            //SEM LOADER BLOQUEANTE: SÓ A MENSAGEM DE SUCESSO
            return new Promise((resolve) => {

                this.getNota(() => {
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    resolve();
                });
            });
        },

        alertaMaximoCelula(disciplina, periodo, limite){

            let msg = limite >= this.NOTA_MAXIMA_PERIODO
                        ? `A nota não pode ser superior a ${this.NOTA_MAXIMA_PERIODO}.`
                        : `A soma das notas do período não pode ultrapassar ${this.NOTA_MAXIMA_PERIODO} pontos. O máximo nesta atividade é ${String(limite).replace('.', ',')}.`;

            //TOAST, NÃO MODAL: UM DIÁLOGO AQUI ROUBA O FOCO DO INPUT, DISPARA O blur
            //E ACABA GRAVANDO A NOTA QUE O USUÁRIO AINDA ESTAVA DIGITANDO.
            window.eventBus.$emit('alert', {msg: msg, type: 'warning'});
        },


        openGerenciarCalcMedia(){

            this.loading = true;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/diario/getCalcNotaQtdDvisao/${this.aluno_id}/${this.turma_id}`, this.$store.getters.getHeaderAuth).then(response => {

                if(response.data.calc_nota_qtd_dvisao > 0) {
                    
                    this.calcNota.qtd_dvisao = response.data.calc_nota_qtd_dvisao;
                }

                this.dialogGerenciarCalcMedia = true;
                
                this.loading = false;
                
            }).catch((error) => { this.$store.commit('throwException', error); window.eventBus.$emit('loading', false); });
            
        },
        onSubmitGerenciarCalcMedia() {

            this.$refs.calcNota.validate((valid) =>{ if(valid){

                this.$msgbox.confirm(`Tem certeza que deseja alterar a fórmula de cálculo da média deste aluno?`, 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                    window.eventBus.$emit('loading', true);

                    let payload = {
                        aluno_id: this.aluno_id,
                        turma_id: this.turma_id,
                        qtd_dvisao: this.calcNota.qtd_dvisao
                    };

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/diario/storeCalcNotaQtdDvisao`, payload, this.$store.getters.getHeaderAuth).then(response => {
                                                
                        if(typeof response.data.erro !== 'undefined'){

                            this.$alert(response.data.erro, 'Atenção', {
                                confirmButtonText: 'OK',
                                type: 'warning'
                            }).catch(()=>{});

                        }else{
                            
                            window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                            this.dialogGerenciarCalcMedia = false;
                        }

                        window.eventBus.$emit('loading', false);

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }).catch(()=>{});

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        },







        handleTabClick(tab) {

            if (tab._props.name === 'observacoes') {
                this.getObservacoes()
            }
        },
        getObservacoes() {

            let payload = {};

            if(this.id) {

                payload['id'] = this.id;

            } else {

                payload['turma_id'] = this.turma_id;
                payload['aluno_id'] = this.aluno_id;
            }

            this.loadingObservacoes = true;

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/diario/getDiarioObservacoes`, payload, this.$store.getters.getHeaderAuth).then(response => {

                this.observacoes = response.data.data; 
                this.paginateObservacoes.qtdItens = response.data.total;
                this.paginateObservacoes.from = response.data.from;
                this.paginateObservacoes.to = response.data.to;

                this.loadingObservacoes = false;

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
        },
        removerNota(disciplina, periodo, atividade){

            if(!this.mostra_gerenciar_nota) {
                return;
            }

            if(this.$store.state.user.tipo == 7){
                return;
            }

            this.$msgbox.confirm('Tem certeza que deseja excluir este nota? Não será possível desfazer a exclusão.', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);

                let payload = {
                    aluno_id: this.aluno_id,
                    turma_id: this.turma_id,
                    disciplina,
                    periodo,
                    atividade
                };

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/nota/removerNota`, payload, this.$store.getters.getHeaderAuth).then(response => {

                    if(typeof response.data.error !== 'undefined'){

                        this.$alert(response.data.error, 'Atenção', { confirmButtonText: 'OK' });

                    }else{

                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.getNota();
                    }

                    window.eventBus.$emit('loading', false);

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});

        },  
        abrirParecer(periodo, periodoNome, parecerAtual) {

            if(!this.podeEditarParecer) {
                return;
            }

            this.changeParecer = {
                aluno_id: this.aluno_id ? this.aluno_id : this.nota.aluno_id,
                turma_id: this.turma_id ? this.turma_id : this.nota.turma_id,
                periodo: periodo,
                periodo_nome: periodoNome,
                parecer: parecerAtual ? parecerAtual : ''
            };

            this.dialogChangeParecer = true;
        },
        onSubmitChangeParecer() {

            window.eventBus.$emit('loading', true);

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/nota/customParecer`, this.changeParecer, this.$store.getters.getHeaderAuth).then(response => {

                if(typeof response.data.error !== 'undefined'){

                    this.$alert(response.data.error, 'Atenção', { confirmButtonText: 'OK' });

                }else{

                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    this.getNota();
                    this.dialogChangeParecer = false;
                }

                window.eventBus.$emit('loading', false);

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
        },
        closeDialogChangeParecer() {

            this.changeParecer = { aluno_id: '', turma_id: '', periodo: '', periodo_nome: '', parecer: '' };
        },
        selecionaNota(disciplina, periodo) {

            if(!this.mostra_gerenciar_nota) {
                return;
            }

            if(this.$store.state.user.tipo == 7){
                return;
            }

            this.changeNota.aluno_id = this.aluno_id;
            this.changeNota.disciplina = disciplina;
            this.changeNota.periodo = periodo;
            this.changeNota.turma_id = this.turma_id;
            this.dialogChangeNota = true;
        },
        onSubmitChangeNota() {

            this.$refs.changeNota.validate((valid) =>{ if(valid){

                window.eventBus.$emit('loading', true);

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/nota/customNota`, this.changeNota, this.$store.getters.getHeaderAuth).then(response => {

                    if(typeof response.data.error !== 'undefined'){

                        this.$alert(response.data.error, 'Atenção', { confirmButtonText: 'OK' });

                    }else{

                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.getNota();
                        this.dialogChangeNota = false;
                    }

                    window.eventBus.$emit('loading', false);

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
                

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        },
        closeDialogChangeNota() {
            
            this.changeNota = {
                aluno_id: '',
                turma_id: '',
                disciplina: '',
                periodo: '',
                nota: '',
                observacao: ''
            };
        },
        getNota(aoTerminar){

            this.loadingNota = false;

            let payload = {};

            if(this.id) {

                payload['id'] = this.id;

            } else {

                payload['turma_id'] = this.turma_id;
                payload['aluno_id'] = this.aluno_id;
            }
            
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/nota/getNotaByFiltros`, payload, this.$store.getters.getHeaderAuth).then(response => {

                if(typeof response.data.error !== 'undefined'){

                    window.eventBus.$emit('alert', {msg: response.data.error, type: 'warning'});
                    this.$emit('close');

                }else{

                    this.nota = response.data; 
                                                          
                    if(this.nota.turma.metodo_avaliacao == 'quantitativo')
                        this.montaGrade();

                    this.loadingNota = false;

                    if(typeof aoTerminar === 'function')
                        aoTerminar();

                } 

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
        },     
        close(){
            this.$emit('close');
        },
        getPagePagination(page){
          this.paginateObservacoes.page = page;
          this.getObservacoes();
        },
        formatarTexto(texto) {

            if(texto == '' || texto == null) {
                return texto;
            }

            texto = texto.toLowerCase();

            const partes = texto.split(" ");

            partes[0] = partes[0].charAt(0).toUpperCase() + partes[0].slice(1);

            return partes.join(" ");
        }
    },
    components:{ Decimal, 'nota-input': NotaInput }
}
</script>
<style>
    /* o input ocupa a célula inteira: a borda quem desenha é o <td> */
    .celula-nota {
        padding: 0 !important;
        width: 46px;
    }
    .celula-nota .el-input,
    .celula-nota .el-input__inner {
        width: 100%;
        display: block;
    }
    .celula-nota .el-input__inner {
        border: none;
        border-radius: 0;
        text-align: center;
        padding: 0 2px;
        height: 25px;
        line-height: 25px;
        font-size: 12px;
        background: transparent;
    }
    .celula-nota .el-input__inner:focus {
        background: #eaf5fc;
    }
    /* mesma sinalização de antes: destaca a nota lançada pelo próprio usuário */
    .celula-nota .minha-nota .el-input__inner {
        color: #00aaff;
        font-weight: bold;
    }

    /* com 8 colunas a tabela não cabe e espremia o nome da disciplina */
    .bloco-periodo {
        overflow-x: auto;
    }
    .col-disciplina {
        white-space: nowrap;
        min-width: 150px;
    }

    /* botão de editar parecer: canto superior direito do bloco, sem deslocar o texto */
    .fieldset-nota {
        position: relative;
    }
    .btn-editar-parecer {
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 2;
    }
    .table-nota td, .table-nota th {
        border: 1px solid #ccc !important;
    }
    .vertical-text {
        writing-mode: vertical-rl;
        transform: rotate(180deg);
        padding: 10px;
        height: 90px;
        text-align: center;
        width: 35px !important;
    }
    .input-nota .el-input__inner {
        border: none !important;
        background-color: #efefef;
        text-align: center;
    }

    .table-nota.table th, .table-nota.table td {
        padding: 0px !important;
    }

    .linha-nota th, .linha-nota td {
        height: 25px !important;
    }

    .fieldset-nota{
        min-height: 150px;
        text-transform: uppercase;
        padding: 10px;
        border-radius: 10px;
        margin: 20px 0;
    }

</style>